import { render } from "./ListPaginationSkeleton.vue?vue&type=template&id=4ca215be&scoped=true"
import script from "./ListPaginationSkeleton.vue?vue&type=script&lang=js"
export * from "./ListPaginationSkeleton.vue?vue&type=script&lang=js"

import "./ListPaginationSkeleton.vue?vue&type=style&index=0&id=4ca215be&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca215be"]])

export default __exports__